a.loader = (function(){
	return {
		fs:{
			create:function(){
				var c = '<div id="fsloader">';
				c += '<span><i class="fa fa-3x fa-spinner-third fa-spin"></i></span>';
				c += '</div>';
				$('body').append(c);
				setTimeout(function(){
					a.loader.fs.remove();
				}, 8000);
			},
			remove:function(){
				$('#fsloader').hide(0,function(){
					$(this).remove();
				});
			}
		},
		fsprog:{
			create:function(txt,cb_ready,cb_cancel){
				var c = '<div id="fsloader">';
				c += '<span>';
				c += '<div class="txt">'+txt+'</div>';
				c += '<div class="prog"><div class="bar" style="width:1%;"></div></div>';
				c += '<button data-action="fsloader_cancel">Cancel</button>';
				c += '</span>';
				c += '</div>';
				$('body').append(c);
				$('#fsloader button[data-action="fsloader_cancel"]').unbind('click').click(function(){
					cb_cancel();
					a.loader.fsprog.remove();
				});
				cb_ready(function(pct){
					$('#fsloader .prog .bar').css("width",pct+"%");
				},function(){
					// Done
					a.loader.fsprog.remove();
				});
			},
			remove:function(){
				$('#fsloader').remove();
				$('#fsloader').hide(0,function(){
					$(this).remove();
				});
			}
		},
		area:{
			create:function(area){
				area.empty().append('<div class="loader inline"><i class="fa fa-sync fa-spin"></i></div>');
			},
			remove:function(area){
				$('>.loader',area).remove();
			}
		},
		areasmall:{
			create:function(area){
				area.empty().append('<div class="loader small inline"><i class="fa fa-sync fa-spin"></i></div>');
			},
			remove:function(area){
				$('>.loader',area).remove();
			}
		}
	}
}());